<template>
  <div>
    <b-progress class="ds-progress mt-2" :max="documentTest.questionCount" show-value>
      <b-progress-bar :value="documentTest.currentQuestion" variant="success"/>
    </b-progress>

      <div class="text-center my-3">
        <h4>{{ documentTest.currentQuestionTitle }}</h4>
      </div>
      <div class="row justify-content-center">
        <ul class="col-auto"><li v-for="(answer, i) in documentTest.currentQuestionAnswers"
            :key="`answer-${i}`">{{ answer.title }}</li>
        </ul>

      </div>
      <div class="row justify-content-center my-3">
        <button @click="documentTest.goBack()"
          class="ds-btn ds-btn--default mr-3"
          :class="{'ds-btn--disabled': documentTest.isFirstQuestion}"
          :disabled="documentTest.isFirstQuestion"
          >
            Iepriekšējais
        </button>
         <button class="ds-btn ds-btn--default" 
                :class="{'ds-btn--disabled': documentTest.isLastQuestion}"
            @click="documentTest.goToNextQuestion()"
            :disabled="documentTest.isLastQuestion">
          Nākamais
        </button>

      </div>
      <div class="row justify-content-center my-3"
           v-if="documentTest.isLastQuestion">
        <button class="ds-btn ds-btn--default" 
              @click="$emit('closePreview')">
          Atgriezties pie dokumenta
        </button>
        </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as documentStoreTypes from "../../vuex/modules/document/document.store-types";
import {DocumentTest} from '../../vuex/modules/document/models/document-test.models';
export default {
  name: "document-test-preview",
  data: () => ({ documentTest: null }),
  async created() {
    this.documentTest = new DocumentTest(this.currentDocument.documentForm);
  },
  computed: mapGetters("document", {
    currentDocument: documentStoreTypes.GET_CURRENT_DOCUMENT,
  }),
  methods: {
    
  }
};
</script>